module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving5-15c0eed3a87185b8745b9f2db8d89a22.jpg";